import { useExperimentalQuery } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalQuery';
import { MediaType } from '@confluence/graphql/entry-points/MediaType';

export const useExperimentalThemeSpaceHomeOverrideQuery = ({
	skip,
	variables,
}: {
	skip?: boolean;
	variables: ExperimentalThemeSpaceHomeOverrideQueryVariables;
}) => {
	const { themeAddonKey, themeModuleKey, spaceKey, spaceHomePageId } = variables;

	return useExperimentalQuery<
		ExperimentalThemeSpaceHomeOverrideQueryData,
		ExperimentalThemeSpaceHomeOverrideQueryVariables,
		ExperimentalConnectIFrame | null
	>({
		url: () => {
			if (!themeAddonKey || !themeModuleKey) {
				// This will be handled by parseResponseOnError to return expected data when these keys are missing
				throw new Error('themeAddonKey and themeModuleKey are missing');
			}
			return `/wiki/plugins/servlet/ac/${themeAddonKey}/${themeModuleKey}/?classifier=json&space.key=${spaceKey}&content.id=${spaceHomePageId}&content.type=page`;
		},
		method: 'GET',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		parseResponseOnError: () => null,
		parseResult: (data: ExperimentalConnectIFrame | null) => ({
			experimentalThemeSpaceHomeOverride: {
				hasSpaceHomeOverride: data !== null,
				spaceHomeOverrideDescriptor: data,
			},
		}),
		skip,
		variables,
	});
};

type ExperimentalThemeAPIMigrations = {
	gdpr?: boolean | null;
};

type ExperimentalConnectIFrame = {
	addon_key?: string | null;
	apiMigrations?: ExperimentalThemeAPIMigrations | null;
	contentClassifier?: string | null;
	contextJwt?: string | null;
	cp?: string | null;
	general?: string | null;
	h?: string | null;
	hostOrigin?: string | null;
	key?: string | null;
	moduleType?: string | null;
	origin?: string | null;
	productCtx?: string | null;
	sandbox?: string | null;
	structuredContext?: string | null;
	timeZone?: string | null;
	uniqueKey?: string | null;
	url?: string | null;
	w?: string | null;
};

interface ExperimentalThemeSpaceHomeOverrideQueryData {
	experimentalThemeSpaceHomeOverride: {
		hasSpaceHomeOverride: boolean;
		spaceHomeOverrideDescriptor: ExperimentalConnectIFrame | null;
	};
}

interface ExperimentalThemeSpaceHomeOverrideQueryVariables {
	themeAddonKey?: string | null;
	themeModuleKey?: string | null;
	spaceKey: string;
	spaceHomePageId: string;
}
